<div class="ipt-number-default">
    <label *ngIf="label!=''">{{label}}</label>
    <input type="number" name="quantity"
        [min]="min"
        [max]="max"
        [label]="'Zoom'"
        [disabled]="disabled"
        class="ipt-number-input"
        [ngModel]="value"
        (ngModelChange)="onChange($event)"/>
</div>
